import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { getActiveError } from '../store/error/selectors';
import { devices } from '../styles/viewports.styles';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { StepTitle } from '../views-components/StepTitle';
import { StyledUILink } from '../views-components/TextInput.styles';
import { BaseErrorView } from './BaseErrorView';
import { ErrorKey } from './ErrorKey';
const ErrorContent = styled.div.withConfig({
  displayName: "StandardError__ErrorContent",
  componentId: "sc-1lxrdc3-0"
})(["@media ", "{max-width:", ";}"], devices.desktop, props => props.maxWidth ? props.maxWidth : '75%');

const StandardError = ({
  errorKey = ErrorKey.InternalError,
  handleButtonClick,
  handleLinkClick,
  hasImage = true,
  imageURL = imageUrls.computerError,
  linkToHelpResources = false,
  onSentenceWithLinkClick,
  href = '',
  renderContent,
  isButtonLoading = false
}) => {
  const getHelpResourcesLink = () => {
    return `https://help.hubspot.com/`;
  };

  const currentError = useSelector(getActiveError);

  const renderImage = () => {
    return hasImage && /*#__PURE__*/_jsx(UIImage, {
      className: "m-all-auto m-bottom-8",
      height: 200,
      responsive: true,
      src: imageURL
    });
  };

  const renderTitle = () => {
    return /*#__PURE__*/_jsx(StepTitle, {
      message: `error.${errorKey}.title`,
      stepKey: errorKey
    });
  };

  const renderSubtitle = () => {
    return /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      className: "m-bottom-5",
      message: `error.${errorKey}.subtitle`
    });
  };

  const renderButton = () => {
    return handleButtonClick && /*#__PURE__*/_jsx(UILoadingButton, {
      className: "text-center m-all-auto m-bottom-5 m-top-5",
      "data-selenium": `${errorKey}_button`,
      loading: isButtonLoading,
      use: "primary",
      onClick: handleButtonClick,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `error.${errorKey}.buttonCTA`
      })
    });
  };

  const renderLink = () => {
    return handleLinkClick && /*#__PURE__*/_jsx(UIButton, {
      className: "text-center",
      "data-selenium": `${errorKey}_link`,
      use: "link",
      onClick: handleLinkClick,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `error.${errorKey}.linkCTA`
      })
    });
  };

  const renderSentenceWithLink = () => {
    return onSentenceWithLinkClick && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `error.${errorKey}.sentenceWithLink`,
      options: {
        link: /*#__PURE__*/_jsx(StyledUILink, {
          href: href,
          onClick: onSentenceWithLinkClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `error.${errorKey}.link`
          })
        })
      }
    });
  };

  const renderLinkToHelpResources = () => {
    return linkToHelpResources && /*#__PURE__*/_jsx(FormattedReactMessage, {
      className: "m-top-5",
      message: `error.${errorKey}.helpResourcesSentence`,
      options: {
        helpResourcesLink: /*#__PURE__*/_jsx(StyledUILink, {
          external: true,
          href: getHelpResourcesLink(),
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `error.${errorKey}.checkHelpResources`
          })
        })
      }
    });
  };

  return /*#__PURE__*/_jsx(BaseErrorView, {
    errorKey: errorKey,
    children: /*#__PURE__*/_jsxs(ErrorContent, Object.assign({
      className: "display-flex flex-column m-x-auto"
    }, currentError === ErrorKey.AlreadyAPartner && {
      maxWidth: '90%'
    }, {
      children: [renderImage(), renderTitle(), renderSubtitle(), renderContent && renderContent(), renderButton(), renderLink(), renderSentenceWithLink(), renderLinkToHelpResources()]
    }))
  });
};

export default StandardError;